import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'te_cookie_consent';

const CookieConsent: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(STORAGE_KEY);
    if (!consent) setVisible(true);
  }, []);

  const save = (value: 'accepted' | 'essential') => {
    localStorage.setItem(STORAGE_KEY, value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[100] p-4">
      <div className="max-w-4xl mx-auto bg-white border border-surface-200 shadow-strong rounded-xl p-6 flex flex-col md:flex-row gap-4 items-start md:items-center justify-between">
        <div className="flex-1">
          <p className="font-semibold text-primary-900 mb-1">Usamos cookies</p>
          <p className="text-sm text-surface-600">
            Utilizamos cookies esenciales y, con tu consentimiento, analíticas para mejorar el servicio.
            Consulta nuestra <Link to="/legal/cookies" className="text-gold-700 underline">Política de Cookies</Link>.
          </p>
        </div>
        <div className="flex flex-wrap gap-2 shrink-0">
          <button onClick={() => save('essential')} className="btn-outline btn-sm">
            Solo esenciales
          </button>
          <button onClick={() => save('accepted')} className="btn-gold btn-sm">
            Aceptar todas
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
